{
    "Profile_CommonComponents_Recap.taxesIncluded": "FR: {estimatedAnnualGross} per year (taxes included)",
    "Profile_CommonComponents_Recap.savings": "FR: Or {estimatedMonthlyGross} per month",
    "Profile_CommonComponents_Recap.downloadBinder": "FR: Download Binder"
}
